import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

interface CustomIconProps extends IconProps {
  variant?: string
}

const EyeHiddenOutline = createIcon({
  displayName: 'EyeHiddenOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 19c-.842 0-1.685-.178-2.504-.495"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20.882 12.468c-1.892 3.499-5.387 6.532-8.882 6.532"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.079 8.921c.691.809 1.305 1.691 1.803 2.612 .157.291.157.644 0 .935"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 19l14-14"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.773 14.227c-1.23-1.23-1.23-3.225 0-4.455 1.23-1.23 3.225-1.23 4.455 0"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.044 6.956c-1.547-1.197-3.296-1.956-5.044-1.956 -3.495 0-6.99 3.033-8.882 6.533 -.157.291-.157.644 0 .935 .946 1.749 2.292 3.381 3.838 4.577"
        ></path>
      </g>
    </>
  ),
})

const EyeHiddenTwTone = createIcon({
  displayName: 'EyeHiddenTwTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g fill="none">
        <path d="M0 0h24v24h-24Z"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M12 19c-.842 0-1.685-.178-2.504-.495"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M20.882 12.468c-1.892 3.499-5.387 6.532-8.882 6.532"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M19.079 8.921c.691.809 1.305 1.691 1.803 2.612 .157.291.157.644 0 .935"
        ></path>
        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M5 19l14-14"></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M9.773 14.227c-1.23-1.23-1.23-3.225 0-4.455 1.23-1.23 3.225-1.23 4.455 0"
        ></path>
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M17.044 6.956c-1.547-1.197-3.296-1.956-5.044-1.956 -3.495 0-6.99 3.033-8.882 6.533 -.157.291-.157.644 0 .935 .946 1.749 2.292 3.381 3.838 4.577"
        ></path>
      </g>
    </>
  ),
})

const EyeHidden: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={EyeHiddenTwTone} {...props} />

  return <CustomIcon as={EyeHiddenOutline} {...props} />
}

export default memo(EyeHidden)
